import CaptainAgentToolAPI from 'dashboard/api/captain/agentTool';

const state = {
  records: {}, // keyed by assistant_id
  types: null,
  uiFlags: { fetching: false, saving: false, deleting: false, testing: false },
};

const getters = {
  getToolsForAssistant: s => assistantId => s.records[assistantId] || [],
  getTypes: s => s.types,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_TOOLS(s, { assistantId, tools }) {
    s.records = { ...s.records, [assistantId]: tools };
  },
  ADD_TOOL(s, { assistantId, tool }) {
    const existing = s.records[assistantId] || [];
    s.records = { ...s.records, [assistantId]: [...existing, tool] };
  },
  UPDATE_TOOL(s, { assistantId, tool }) {
    const existing = s.records[assistantId] || [];
    s.records = {
      ...s.records,
      [assistantId]: existing.map(t => (t.id === tool.id ? tool : t)),
    };
  },
  DELETE_TOOL(s, { assistantId, toolId }) {
    const existing = s.records[assistantId] || [];
    s.records = {
      ...s.records,
      [assistantId]: existing.filter(t => t.id !== toolId),
    };
  },
  SET_TYPES(s, types) {
    s.types = types;
  },
  SET_UI_FLAG(s, flag) {
    s.uiFlags = { ...s.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }, assistantId) {
    commit('SET_UI_FLAG', { fetching: true });
    try {
      const { data } = await CaptainAgentToolAPI.list({ assistantId });
      commit('SET_TOOLS', { assistantId, tools: data });
      return data;
    } finally {
      commit('SET_UI_FLAG', { fetching: false });
    }
  },

  async fetchTypes({ commit, state: s }, assistantId) {
    if (s.types) return s.types;
    const { data } = await CaptainAgentToolAPI.types({ assistantId });
    commit('SET_TYPES', data);
    return data;
  },

  async create({ commit }, { assistantId, payload }) {
    commit('SET_UI_FLAG', { saving: true });
    try {
      const { data } = await CaptainAgentToolAPI.create({
        assistantId,
        payload,
      });
      commit('ADD_TOOL', { assistantId, tool: data });
      return data;
    } finally {
      commit('SET_UI_FLAG', { saving: false });
    }
  },

  async update({ commit }, { assistantId, toolId, payload }) {
    commit('SET_UI_FLAG', { saving: true });
    try {
      const { data } = await CaptainAgentToolAPI.update({
        assistantId,
        toolId,
        payload,
      });
      commit('UPDATE_TOOL', { assistantId, tool: data });
      return data;
    } finally {
      commit('SET_UI_FLAG', { saving: false });
    }
  },

  async delete({ commit }, { assistantId, toolId }) {
    commit('SET_UI_FLAG', { deleting: true });
    try {
      await CaptainAgentToolAPI.delete({ assistantId, toolId });
      commit('DELETE_TOOL', { assistantId, toolId });
    } finally {
      commit('SET_UI_FLAG', { deleting: false });
    }
  },

  async test({ commit }, { assistantId, toolId, args, conversationId }) {
    commit('SET_UI_FLAG', { testing: true });
    try {
      const { data } = await CaptainAgentToolAPI.test({
        assistantId,
        toolId,
        args,
        conversationId,
      });
      return data;
    } finally {
      commit('SET_UI_FLAG', { testing: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
